import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './data-table-cell.module.scss';

interface DataTableCellProps {
  id: number;
  isFirstChild?: boolean;
  children: ReactNode;
}

export const DataTableCell: React.FC<DataTableCellProps> = ({ children, id, isFirstChild }) => {
  const deepLinkId = parseInt(window.location.hash.replace(/#/, ''));

  const cellClasses = classNames(styles['table-cell'], {
    [styles['highlighted']]: deepLinkId === id,
    [styles['first-child']]: isFirstChild,
  });

  return <div className={cellClasses}>{children}</div>;
};
